"use client";

import { useEffect } from "react";
import ContactCard from "@/components/contact-card";
import ContactForm from "@/components/contact-form";
import FAQAccordion from "@/components/faq-accordion";
import Footer from "@/components/footer";

export default function ClientContactPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <main className="min-h-screen bg-white">
      {/* Section 1: Talk to an Expert */}
      <section className="mx-auto max-w-7xl px-6 md:px-10 py-10 md:py-14">
        <div className="mb-8 md:mb-12 text-center">
          <h1 className="mb-2 text-[28px] sm:text-[32px] md:text-5xl font-bold text-black">
            Talk to an Expert
          </h1>
          <p className="text-[14.5px] md:text-lg text-muted-foreground">
            Connect with us for personalized support and expert guidance.
          </p>
        </div>

        <div className="grid grid-cols-1 gap-4 sm:gap-5 md:gap-6 md:grid-cols-3">
          <ContactCard
            type="phone"
            title="CALL US"
            content="+1 (410) 604-1400"
          />
          <ContactCard
            type="address"
            title="ADDRESS"
            content={[
              "1625 Sonny Schulz Blvd Suites,",
              "Stevensville, Maryland 21666",
            ]}
          />
          <ContactCard
            type="email"
            title="EMAIL US"
            content="info@michmfg.com"
          />
        </div>
      </section>

      {/* Section 2: Submit an Inquiry */}
      <section className="mx-auto max-w-7xl px-6 md:px-10 pt-6 md:pt-8 pb-10 md:pb-14">
        <div className="grid grid-cols-1 gap-8 md:gap-12 lg:grid-cols-2">
          <div className="flex flex-col justify-start">
            <h2 className="mb-3 md:mb-4 text-[26px] sm:text-[30px] md:text-5xl font-bold text-black">
              Submit an Inquiry
            </h2>
            <p className="text-[14.5px] md:text-xl leading-relaxed text-muted-foreground">
              Got a vision for your next project? Let&apos;s bring it to life!
              Reach out with your questions — we&apos;re here to help.
            </p>
          </div>

          <ContactForm />
        </div>
      </section>

      {/* Section 3: FAQs */}
      <section className="mx-auto max-w-7xl px-6 md:px-10 pt-6 md:pt-8 pb-12 md:pb-16">
        <div className="grid grid-cols-1 gap-6 md:gap-10 lg:grid-cols-2">
          <div className="flex flex-col justify-start">
            <h2 className="mb-3 md:mb-4 text-[26px] sm:text-[30px] md:text-5xl font-bold text-black">
              FAQs:
            </h2>
            <p className="text-[14.5px] md:text-xl leading-relaxed text-muted-foreground">
              Find answers to common questions below. If you need more help,
              feel free to reach out!
            </p>
          </div>

          {/* smaller top margin so first item sits closer to subheading */}
          <div className="mt-2 md:mt-3">
            <FAQAccordion />
          </div>
        </div>
      </section>

      <Footer />
    </main>
  );
}
